// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__BrFnV","footer":"ModalError_footer__1I5at"};